import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
export type StyleProps = {};
export const useStyles = makeStyles<Theme, StyleProps>(() =>
  createStyles({
    global: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: 1,
    },
  })
);
